var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-center font-size-12 c-59" }, [
    _c(
      "span",
      { staticClass: "hand c-43-h", on: { click: _vm.toggleShow } },
      [
        _c("span", { staticClass: "v-mid mr8" }, [
          _vm._v(
            _vm._s(
              _vm.$t(_vm.open ? "pc_o2o_lbl_hidemore" : "pc_o2o_lbl_showmore")
            )
          ),
        ]),
        _c("yxtpd-svgf", {
          staticClass: "v-mid",
          attrs: {
            front: "",
            name: _vm.open ? "up" : "down",
            width: "16px",
            height: "16px",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }